import React from "react";
import { Link } from "react-router";
import Card from "material-ui/Card";
import CardActions from "material-ui/Card/CardActions";
import CardHeader from "material-ui/Card/CardHeader";
import CardMedia from "material-ui/Card/CardMedia";
import CardTitle from "material-ui/Card/CardTitle";
import CardText from "material-ui/Card/CardText";
import FlatButton from "material-ui/FlatButton";
import FontIcon from "material-ui/FontIcon";
import Paper from "material-ui/Paper";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/MenuItem";
import Popover from "material-ui/Popover";

const JobCard = React.createClass({
  renderAction(action, i) {
    const style = { color: "#2979ff" };
    return (
      <MenuItem
        key={i}
        primaryText={action.title}
        style={style}
        onClick={this.props.performRoute.bind(
          this,
          "/job/" + this.props.link + "/" + action.route,
        )}
      />
    );
  },

  render() {
    const style = { backgroundColor: "#ebeff2" };

    return (
      <div>
        <Card zDepth={2}>
          <CardHeader
            style={style}
            title={this.props.title}
            titleColor={this.props.titleColor}
            actAsExpander={true}
            showExpandableButton={true}
          />
          <CardActions expandable={true}>
            {this.props.actions.map(this.renderAction)}
          </CardActions>
        </Card>
        {/*<Card zDepth={2}>
					<a onClick={this.props.performRouteAndUpdate.bind(null, "/job/"+this.props.link, this.props.endpoint)}>
						<Paper zDepth={1}>
							<CardTitle title={this.props.title} subtitle={this.props.subTitle} style={style} titleColor={this.props.titleColor}/>
							<div style={style} />
						</Paper>
					</a>
					<Menu>
						{this.props.actions.map(this.renderAction)}
					</Menu>
				</Card>*/}
      </div>
    );
  },
});

export default JobCard;



// WEBPACK FOOTER //
// ./app/components/JobCard.js